import React from 'react';
import cn from 'classnames';

const DeleteAttachBtn = ({ onClick, className }) => (
  <div onClick={onClick} className={cn(className, 'delete-button')}>
    <img alt="удалить вложение" src="img/delete-stop.svg" />
  </div>
);

export default DeleteAttachBtn;
